import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-list',
  imports: [],
  templateUrl: './list.html',
  styleUrl: './list.scss',
})
export class List {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}